<appshell-main [plugins]="{ user: userInfoPlugin }" (clickOnComponent)="handleClick($event)">
    @for (activeDialog of activeDialogs$ | async; track activeDialog) {
        <priva-dynamic-component-slot
            class="priva-dynamic-component"
            data-dynamic-slot
            [dynamicComponent]="activeDialog"
        />
    }
    <ng-template #userInfoPlugin>
        <app-user-session-info />
    </ng-template>
</appshell-main>
